import { useTranslation } from "react-i18next";

export const Postdoctor = () => {
    const { t } = useTranslation();

    return [
        {
            imgURL: "/images/members/postDoc/ying_siou.jpg",
            name: {
                chinese: "陳盈秀",
                english: "Ying Siou Chen"
            },
            email: "amy780617@gmail.com",
            spec: t("page.member.info.postdoctor.Ying Siou.spec")
        },

        {
            imgURL: "/images/members/postDoc/Shu_Hao.jpg",
            name: {
                chinese: "吳書豪",
                english: "Shu Hao Wu"
            },
            email: "shwu1356@gmail.com",
            spec: t("page.member.info.postdoctor.Shu Hao.spec")
        }

    ]
}
